import { supabase } from '@cleanpro/common-ui';
import { Employee } from './types';

export async function fetchAllEmployees() {
  const { data, error } = await supabase
    .from('employees')
    .select('*')
    .order('created_at', { ascending: false });
    
  if (error) throw error;
  return data;
}

export async function getEmployeeById(employeeId: string) {
  const { data, error } = await supabase
    .from('employees')
    .select('*')
    .eq('id', employeeId)
    .single();

  if (error) throw error;
  return data;
}

export async function addEmployee(employeeData: Omit<Employee, 'id'>) {
  const employeeToInsert = {
    name: employeeData.name,
    email: employeeData.email,
    phone: employeeData.phone,
    role: employeeData.role,
    status: employeeData.status,
    hire_date: employeeData.hireDate,
    hourly_rate: employeeData.hourlyRate,
    user_id: employeeData.userId
  };

  const { data, error } = await supabase
    .from('employees')
    .insert([employeeToInsert])
    .select()
    .single();
    
  if (error) throw error;
  return data;
}